<!-- @format -->
<template>
  <el-dialog
    title="企业确认授信"
    :visible.sync="show"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :before-close="closeDialog"
    width="1100px"
    top="5vh"
    destroy-on-close
  >
    <div class="dialog-content">
      <!-- 订单信息 -->
      <div class="section-title">订单信息</div>
      <el-descriptions :column="3" border size="small">
        <el-descriptions-item label="订单编号">{{ form.orderNo }}</el-descriptions-item>
        <el-descriptions-item label="订单状态">{{ statusLabel }}</el-descriptions-item>
        <el-descriptions-item label="下单时间">{{ form.createTime }}</el-descriptions-item>
      </el-descriptions>

      <!-- 产品信息 -->
      <div class="section-title">产品信息</div>
      <el-table :data="tableData" stripe border size="small" style="width: 100%">
        <el-table-column prop="cpmc" label="产品名称" width="150" />
        <el-table-column label="利率范围">
          <template slot-scope="scope">
            {{ scope.row.zdnhlv }}% - {{ scope.row.zgnhlv }}%
          </template>
        </el-table-column>
        <el-table-column label="贷款期限（月）" width="110">
          <template slot-scope="scope">
            {{ scope.row.dkqxxx }} - {{ scope.row.dkqxsx }}
          </template>
        </el-table-column>
        <el-table-column label="贷款额度（万元）" width="120">
          <template slot-scope="scope">
            {{ scope.row.dkedxx }} - {{ scope.row.dkedsx }}
          </template>
        </el-table-column>
        <el-table-column prop="dbfsm" label="担保方式" />
        <el-table-column prop="dklxm" label="贷款类型" />
        <el-table-column prop="khjl" label="客户经理" width="80" />
        <el-table-column prop="lxrdh" label="联系电话" width="110" />
        <el-table-column prop="jrjgmg" label="所属机构" width="160" />
      </el-table>

      <!-- 企业融资需求 -->
      <div class="section-title">企业融资需求</div>
      <el-descriptions :column="3" border size="small">
        <el-descriptions-item label="申请企业">{{ form.qymc }}</el-descriptions-item>
        <el-descriptions-item label="贷款额度（万元）">{{ form.dked }}</el-descriptions-item>
        <el-descriptions-item label="贷款期限（月）">{{ form.dkqx }}</el-descriptions-item>
        <el-descriptions-item label="年利率（%）">{{ form.nhlv }}</el-descriptions-item>
        <el-descriptions-item label="担保方式">{{ form.dbfsm }}</el-descriptions-item>
        <el-descriptions-item label="信贷类型">{{ form.dklxm }}</el-descriptions-item>
        <el-descriptions-item label="联系人">{{ form.khjl }}</el-descriptions-item>
        <el-descriptions-item label="联系方式">{{ form.lxrdh }}</el-descriptions-item>
        <el-descriptions-item label="审核意见">{{ form.suggest || '-' }}</el-descriptions-item>
        <el-descriptions-item label="授信意见" :span="3">
          {{ form.creditSuggest || '-' }}
        </el-descriptions-item>
      </el-descriptions>

      <!-- 确认授信意见 -->
      <div class="section-title">确认授信</div>
      <el-form :model="form" label-width="120px" class="confirm-form">
        <el-form-item label="确认意见">
          <el-input
            v-model="form.qyCreditSuggest"
            type="textarea"
            :rows="4"
            placeholder="请输入确认意见"
            maxlength="300"
            show-word-limit
          />
        </el-form-item>
      </el-form>
    </div>

    <template #footer>
      <div class="dialog-footer">
        <!-- <el-button size="small" @click="closeDialog">取 消</el-button> -->
        <el-button size="small" type="danger" @click="handleConfirm(false)">不同意授权</el-button>
        <el-button size="small" type="primary" @click="handleConfirm(true)">同意授权</el-button>
      </div>
    </template>
  </el-dialog>
</template>

<script>
import { getDetailPortals, productOrder } from './viewApi'

export default {
  name: 'creditConfirmDialog',
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    rowData: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      tableData: [],
      form: {
        orderNo: '',
        createTime: '',
        qymc: '',
        creditSuggest: '',
        lxrdh: '',
        khjl: '',
        dklxm: '',
        dbfsm: '',
        zgnhlv: '',
        dkqx: '',
        dked: '',
        nhlv: '',
        suggest: '',
        qyCreditSuggest: '',
      },
      statusList: [
        { status: 1, labal: '待审核' },
        { status: 2, labal: '审核不通过' },
        { status: 3, labal: '授信中' },
        { status: 4, labal: '授信待确认' },
        { status: 5, labal: '金融机构授信不通过' },
        { status: 6, labal: '撮合成功' },
        { status: 7, labal: '企业不同意授信' },
        { status: 8, labal: '已完成' },
      ],
    }
  },
  computed: {
    statusLabel() {
      const item = this.statusList.find((s) => s.status === Number(this.rowData.status))
      return item ? item.labal : ''
    },
  },
  watch: {
    show(val) {
      if (val && this.rowData && this.rowData.id) {
        this.fetchDetail()
      }
    },
  },
  methods: {
    /** 获取订单详情 */
    async fetchDetail() {
      let res = await getDetailPortals({ id: this.rowData.id })
      if (res.data) {
        this.tableData = [res.data]
        this.form = {
          ...res.data,
          qyCreditSuggest: res.data.qyCreditSuggest || '',
        }
      }
    },

    /** 确认授信 */
    handleConfirm(isTrue) {
      let params = {
        id: this.rowData.id,
        status: isTrue ? 6 : 7,
        qyCreditSuggest: this.form.qyCreditSuggest,
      }
      productOrder(params).then((res) => {
        if (res.code == 1000) {
          this.$baseMessage('操作成功', 'success')
          this.$emit('closeDialog', true)
        }
      })
    },

    /** 关闭弹窗 */
    closeDialog() {
      this.$emit('closeDialog')
    },
  },
}
</script>

<style lang="scss" scoped>
.dialog-content {
  padding: 10px 0;
}

.section-title {
  font-size: 15px;
  font-weight: 600;
  color: #000;
  margin: 18px 0 12px 0;
  padding-left: 10px;
  border-left: 3px solid #1366ec;
  line-height: 1;

  &:first-child {
    margin-top: 0;
  }
}

.confirm-form {
  padding: 0 10px;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  padding: 10px 0 0 0;

  // 按钮圆润化与间距优化
  ::v-deep .el-button {
    border-radius: 20px;
    padding: 9px 24px;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.25s ease;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 4px 12px rgba(19, 102, 236, 0.25);
    }

    &:active {
      transform: translateY(0);
    }
  }

  // 默认按钮（取消/关闭）样式优化
  ::v-deep .el-button--default {
    border-color: #dcdfe6;
    color: #606266;

    &:hover {
      color: #1366ec;
      border-color: #1366ec;
      box-shadow: 0 4px 12px rgba(19, 102, 236, 0.15);
    }
  }

  // 危险按钮悬浮阴影
  ::v-deep .el-button--danger:hover {
    box-shadow: 0 4px 12px rgba(245, 108, 108, 0.25);
  }
}
</style>
